import { observable, action, toJS } from "mobx"
// import { ignore } from 'mobx-sync'
import api from "../services/ApiDefault"
import { showResponseError } from "../utilities/utils"
// import Loading from '../utilities/loading'
import authStore from "./AuthStore"
import moment from "moment"
import _ from "lodash"
import { v4 } from "uuid"
import { normalizeConversation } from "./normalizeConversation"

function getCloseTimeLocal(city) {
  if (city === "London") return 3 // 3 AM
  if (city === "Dubai") return 5 // 5 AM
  if (city === "Paris") return 5 // 5 AM
  return 3
}

function getDateByCity(city) {
  const today = moment().local()
  const hourNow = today.hour()
  const hourCity = getCloseTimeLocal(city)
  if (hourNow < hourCity) {
    today.date(today.date() - 1)
  }
  return today
}
const getBookingRecapFromNow = (list) => {
  const newListFromNow = list.filter((i) => {
    const { club, date, status } = i.reservation || {}
    const dateByCity = getDateByCity(club?.city)
    return (
      moment(date).unix() >= moment(dateByCity.format("YYYY-MM-DD")).unix() && status === "opening"
    )
  })
  return newListFromNow.sort(
    (a, b) => moment(b.reservation?.date).unix() - moment(a.reservation?.date).unix()
  )
}

export class ChatStore {
  @observable isLoading = false
  @observable isSending = false
  @observable isUploading = false
  @observable isEndList = false
  @observable conversations = []
  @observable conversation = null
  @observable adminConversation = null
  @observable lastMessage = null
  @observable messages = []
  @observable messageRecap = []
  @observable user = null

  @observable lastPage = 0
  @observable page = 1
  @observable perPage = 100
  @observable total = 0

  @observable unreadCount = 0
  @observable lastTyping = null
  @observable lastUpdate = null
  @observable otherUserTyping = null

  @observable params = {
    perPage: 100,
    page: 1,
    search: "",
  }

  @action
  clearMessages = () => {
    this.messages = []
    this.messageRecap = []
    this.lastPage = 0
    this.page = 0
    this.perPage = 100
    this.total = 0
  }

  @action setConversation = (conversation) => (this.conversation = conversation)
  @action setUser = (user) => (this.user = user)
  @action setOtherUserTyping = (otherUserTyping) => (this.otherUserTyping = otherUserTyping)

  @action
  onReceiveMessage(message) {
    const userId = authStore.user._id
    const user = message.conversation.users.find((u) => u._id !== userId)
    const conversation = this.conversations.find((c) => c._id === message.conversation_id)
    if (this.adminConversation?._id === message.conversation_id) {
      // Object.assign(this.adminConversation, message.conversation)
      this.adminConversation = message.conversation
    } else if (conversation) {
      this.conversations = this.conversations.map((c) =>
        c._id === message.conversation_id ? normalizeConversation(message.conversation, userId) : c
      )
    } else {
      if (user) {
        const newConversation = normalizeConversation(message.conversation, userId)
        if (user.role === "customer_service") {
          this.adminConversation = newConversation
        } else {
          this.conversations.unshift(newConversation)
        }
      }
    }
    const currentMessage = this.messages.find((m) => m.uuid === message.uuid)
    if (!currentMessage && message.user_id !== authStore.user._id) {
      if (message.conversation_id === this.conversation?._id) {
        this.messages = [
          ...this.messages,
          {
            ...message,
            system: message.type === "system",
            // received: message.status === "seen",
            // sent: true,
            createdAt: moment(message.created_at).toDate(),
          },
        ]

        api.readConversation(message.conversation_id)
      } else if (message.user_id !== userId) {
        this.unreadCount = this.unreadCount + 1
      }
    }
    this.lastMessage = message
    this.lastUpdate = new Date().getTime()
  }

  @action
  async sendTyping(conversationId, time) {
    this.lastTyping = time
    const result = await api.sendTyping(conversationId)
    return result.kind
  }

  @action
  async getUserConversation(otherUserId) {
    const userId = authStore.user._id
    const query = JSON.stringify({
      with: ["users"],
      where: { $and: [{ user_ids: userId }, { user_ids: otherUserId }] },
    })
    this.isLoading = true
    const result = await api.getConversations({ query })
    this.isLoading = false
    if (result.ok) {
      if (result.data?.data?.length) {
        const conversation = result.data?.data?.[0]
        if (conversation.users.find((u) => u._id === otherUserId)) {
          this.conversation = normalizeConversation(conversation, userId)
        }
      }
      return null
    } else {
      return showResponseError(result)
    }
  }

  @action
  async getConversations(skip = 0, limit = 1000) {
    const userId = authStore.user._id
    const query = { with: ["users"], sort: "-last_sent", skip, limit }
    // eslint-disable-next-line no-console
    console.log(query)
    this.isLoading = true
    const result = await api.getConversations({
      query: JSON.stringify(query),
    })
    this.isLoading = false
    if (result.ok) {
      const data = result.data?.data || []
      if (data.length === 0) {
        this.isEndList = true
      } else {
        let unreadCount = 0
        const newConversations = []
        for (const conversation of data) {
          const user = conversation.users.find((u) => u._id !== userId)
          if (user) {
            const newConversation = normalizeConversation(conversation, userId)
            if (user.role === "customer_service") {
              this.adminConversation = newConversation
            } else {
              newConversations.push(newConversation)
            }
          }
          unreadCount += conversation.unread_counts?.[userId] || 0
        }
        if (skip > 0) {
          this.conversations = _.uniqBy([...this.conversations, ...newConversations], "_id")
          this.unreadCount = this.unreadCount + unreadCount
        } else {
          this.conversations = newConversations
          this.unreadCount = unreadCount
        }
      }
      return null
    } else {
      return showResponseError(result)
    }
  }

  @action
  async getMessages(conversationId) {
    const query = JSON.stringify({
      with: ["reservation.club", "user", "replied_message.user"],
      sort: "-created_at",
    })
    this.isLoading = true
    const result = await api.getMessages(conversationId, {
      query,
      page: this.page + 1,
      perPage: this.perPage,
    })
    this.isLoading = false
    if (result.ok) {
      const { page, lastPage, perPage, total, data } = result.data
      this.lastPage = lastPage
      this.page = page
      this.perPage = perPage
      this.total = total

      const messages = _.orderBy(
        data
          .filter((message) => message.type !== "booking_recap")
          .map((message) => ({
            ...message,
            system: message.type === "system",
            // received: message.status === "seen",
            // sent: true,
            createdAt: moment(message.created_at).toDate(),
          })),
        ["created_at"],
        ["asc"]
      )
      this.messages = page > 1 ? [...messages, ...this.messages] : messages

      this.messageRecap = getBookingRecapFromNow(data.filter((m) => m.type === "booking_recap"))
    } else {
      return showResponseError(result)
    }
  }

  @action
  async sendMessage(message) {
    message.uuid = v4()
    this.messages = [
      ...this.messages,
      {
        ...message,
        user: {
          _id: authStore.user._id,
        },
        user_id: authStore.user._id,
        _id: message.uuid,
        system: false,
        ...(message.replied_message_id && {
          replied_message: toJS(this.messages.find((m) => m._id === message.replied_message_id)),
        }),
        // received: false,
        // sent: false,
        createdAt: new Date(),
      },
    ]

    this.isSending = true
    const result = await api.sendMessage(message)
    this.isSending = false
    if (result.ok) {
      // return result.data
      // this.onReceiveMessage(result.data.data)
      const newMessages = this.messages.map((m) => {
        if (m.uuid === message.uuid) {
          return {
            ...m,
            status: "sent",
            _id: result.data._id,
          }
        } else {
          return m
        }
      })
      this.messages = newMessages
      this.lastUpdate = new Date().getTime()
    } else {
      return showResponseError(result)
    }
  }

  @action
  async deleteMessage(messageId) {
    this.isLoading = true
    const result = await api.deleteMessage(messageId)
    this.isLoading = false
    if (result.ok) {
      this.messages = this.messages.filter((m) => m._id !== messageId)
      return null
    } else {
      return showResponseError(result)
    }
  }

  @action
  async uploadFile(file) {
    const formData = new FormData()
    formData.append("media", file)
    this.isUploading = true
    const response = await api.uploadMessageFiles(formData)
    this.isUploading = false
    if (response.ok) {
      return response.data
    } else {
      showResponseError(response)
      return null
    }
  }

  @action
  async addConversation(data) {
    const result = await api.addConversation(data)
    if (result.ok) {
      let conversation = this.conversations.find((c) => c._id === result.data.data._id)
      if (!conversation) {
        conversation = result.data.data
        const userId = authStore.user._id
        const user = conversation.users.find((u) => u._id !== userId)
        if (user) {
          const newConversation = normalizeConversation(conversation, userId)
          if (user.role === "customer_service") {
            this.adminConversation = newConversation
          } else {
            this.conversations.unshift(newConversation)
          }
        }
      }
      this.setConversation(conversation)
      return conversation
      // return result.data
      // this.onReceiveMessage(result.data.data)
    } else {
      return showResponseError(result)
    }
  }

  @action
  async readConversation(id) {
    const result = await api.readConversation(id)
    if (result.ok) {
      const conversation = result.data.data
      const userId = authStore.user._id
      if (this.adminConversation?._id === conversation._id) {
        this.adminConversation = conversation
      } else {
        this.conversations = this.conversations.map((c) =>
          c._id === conversation._id ? normalizeConversation(conversation, userId) : c
        )
      }
    } else {
      return showResponseError(result)
    }
  }

  @action
  async deleteConversation(id) {
    const result = await api.deleteConversation(id)
    if (result.ok) {
      return null
    } else {
      return showResponseError(result)
    }
  }

  @action
  async getHandover(conversationId) {
    const result = await api.getHandover(conversationId)
    if (result.ok) {
      return result.data
    } else {
      return showResponseError(result)
    }
  }

  @action
  async respondHandover(conversationId, action) {
    const result = await api.respondHandover(conversationId, action)
    if (result.ok) {
      const userId = authStore.user._id
      const normalized = normalizeConversation(result.data.data, userId)
      if (this.conversation?._id === conversationId) {
        this.conversation = normalized
      }
      return normalized
    } else {
      return showResponseError(result)
    }
  }

  @action
  async addParticipant(conversationId, userId, role = "referral_host") {
    const result = await api.addParticipant(conversationId, userId, role)
    if (result.ok) {
      const myId = authStore.user._id
      const normalized = normalizeConversation(result.data.data, myId)
      if (this.conversation?._id === conversationId) {
        this.conversation = normalized
      }
      return normalized
    } else {
      return showResponseError(result)
    }
  }

  @action
  async removeParticipant(conversationId, userId) {
    const result = await api.removeParticipant(conversationId, userId)
    if (result.ok) {
      const myId = authStore.user._id
      const normalized = normalizeConversation(result.data.data, myId)
      if (this.conversation?._id === conversationId) {
        this.conversation = normalized
      }
      return normalized
    } else {
      return showResponseError(result)
    }
  }

  @action
  async getHostNotes(conversationId, page = 1, perPage = 20) {
    const result = await api.getHostNotes(conversationId, { page, perPage })
    if (result.ok) {
      return result.data
    } else {
      return showResponseError(result)
    }
  }
}

const chatStore = new ChatStore()
export default chatStore
